export class GamepadHandler extends EventTarget {

  _controllers: any;

  constructor() {
    super();
    this._controllers = {};
    window.requestAnimationFrame(this._updateStatus.bind(this));
  }

  /**
   * @param {Gamepad} gamepad 
   */
  addGamepad(gamepad: Gamepad) {
    this._controllers[gamepad.index] = gamepad;
  }

  /**
   * @param {Gamepad} gamepad 
   */
  removeGamepad(gamepad: Gamepad) {
    delete this._controllers[gamepad.index];
  }

  _updateStatus() {
    this._scanGamepad();
    for(let i in this._controllers) {
      const controller = this._controllers[i];

      // gamepadupdated event type is own definition
      this.dispatchEvent(new GamepadEvent('gamepadupdated', {
        gamepad: controller
      }));
    }
    window.requestAnimationFrame(this._updateStatus.bind(this));
  }

  _scanGamepad() {
    let gamepads = navigator.getGamepads();
    for (let i = 0; i < gamepads.length; i++) {
      if (gamepads[i] != null) {
        const index = gamepads[i]?.index;
        if(index && index in this._controllers) {
          this._controllers[index] = gamepads[i];
        }
      }
    }
  }    
}

